<template>
  <div class="fullscreen-container">
    <!-- 使用绝对定位将 NavHeader 悬浮在图片上方 -->
    <div class="nav-header-container">
      <NavHeader :activeIndex="'home'" :type="'light-dark'" :textColor="'text-white'" />
    </div>

    <!-- 图片容器，设置为全屏 -->
    <div class="image-container">
      <!-- <b-img src="@/assets/images/open/home.gif" class="fullscreen-image" alt="Responsive image" /> -->
      <div class="video-container">
        <video loop="" muted="" preload="preload" autoplay="true" x-webkit-airplay="allow" x5-playsinline=""
          webkit-playsinline="" playsinline="true" x5-video-player-type="h5-page"
          x5-video-orientation="landscape|portrait" poster="@/assets/images/open/home_2.png"
          style="width: 100%; height: 100%;object-fit:cover;object-position:center center"
          class="section-background-video">
          <source type="video/mp4" src="@/assets/images/open/home.mp4">
        </video>
        <div class="video-overlay">
          <div class="overlay-text">
            <span class="text-dark fs-lg-50 fs-md-30 fs-sm-30 fs-sm-80">
              <span class="text-white display-3 font-weight-bolder">FootyForecast足球预测领先者</span>
            </span>
          </div>
        </div>
      </div>
      <!-- 添加文字容器 -->
      <!-- <div class="overlay-text">
        <span class="text-primary fs-lg-50 fs-md-30 fs-sm-50">
          <span style="background-color: rgba(255, 255, 255, 0.8);font-weight: bold;">FootyForecast数据驱动足球预测</span>
        </span>
      </div> -->
      <!-- <b-img src="@/assets/images/open/banner_2.png" class="fullscreen-image" alt="Responsive image" /> -->
      <b-img src="@/assets/images/open/banner_1.png" class="fullscreen-image " alt="Responsive image" />
      <b-img src="@/assets/images/open/banner_3.png" class="fullscreen-image" alt="Responsive image" />
      <b-img src="@/assets/images/open/banner_4.png" class="fullscreen-image mt-20" alt="Responsive image" />
      <b-img src="@/assets/images/open/banner_5.png" class="fullscreen-image" alt="Responsive image" />
      <b-img src="@/assets/images/open/banner_6.png" class="fullscreen-image" alt="Responsive image" />
      <!-- <b-img src="@/assets/images/open/banner_1.png" class="fullscreen-image" alt="Responsive image" /> -->

      <!-- <div
        class="card-body  ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30 ps-xl-40 pe-xl-40 bg-white">
        <div class="row align-items-center text-center e_font_family">
          <div
            class="col-xxl-12 col-lg-12 col-md-12 d-lg-flex d-md-flex  align-items-center justify-content-center p-0 m-0">
            <div
              class="col-xxl-5 col-lg-5 col-md-5 col-sm-12 p-0 m-0  col-sm-5 align-items-center justify-content-center ">
              <div class="text-center text-md-center mt-3 ms-lg-20 ">
                <h1 class="text-primary">
                  ⚽【玩法丰富】⚽
                </h1>
                <h5>🚩滚球大小球、亚让预测</h5>
                <h5>🚩初盘大小球、亚让预测</h5>
                <b-button @click="goDwonload()" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary"
                  class="mt-2 mt-lg-3">
                  👉[快速下载FootyForecast]👈
                </b-button>
              </div>
            </div>

            <div class="col-xxl-7 col-lg-7 col-md-7 col-sm-12  align-items-center p-0 m-0">
              <div class=" align-items-center justify-content-center p-0 m-0 mt-10 ">
                <b-img src="@/assets/images/home/banner_1.png" class="fullscreen-image" alt="Responsive image" />
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <!-- <div
        class="card-body  ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30 ps-xl-40 pe-xl-40 bg-white">
        <div class="row align-items-center text-center e_font_family">
          <div
            class="col-xxl-12 col-lg-12 col-md-12 d-lg-flex d-md-flex  align-items-center justify-content-center p-0 m-0">
            <div
              class="col-xxl-5 col-lg-5 col-md-5 col-sm-12 p-0 m-0  col-sm-5 align-items-center justify-content-center ">
              <div class="text-center text-md-center mt-3 ms-lg-20 ">
                <h1 class="text-primary">
                  👆【技术统计、指数走势】👆
                </h1>
                <h5>
                  "实时技术统计以及指数走势
                  帮助您更好分析赛事动向！"
                </h5>
                <b-button @click="goDwonload()" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary"
                  class="mt-2 mt-lg-3">
                  👉[快速下载FootyForecast]👈
                </b-button>
              </div>
            </div>

            <div class="col-xxl-7 col-lg-7 col-md-7 col-sm-12  align-items-center p-0 m-0">
              <div class=" align-items-center justify-content-center p-0 m-0 mt-10 ">
                <b-img src="@/assets/images/home/banner_5.png" class="fullscreen-image" alt="Responsive image" />
              </div>
            </div>


          </div>
        </div>
      </div> -->




      <!-- <div
        class="card-body  ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30 ps-xl-40 pe-xl-40 bg-white">
        <div class="row align-items-center text-center e_font_family">
          <div
            class="col-xxl-12 col-lg-12 col-md-12 d-lg-flex d-md-flex  align-items-center justify-content-center p-0 m-0">
            <div
              class="col-xxl-5 col-lg-5 col-md-5 col-sm-12 p-0 m-0  col-sm-5 align-items-center justify-content-center ">
              <div class="text-center text-md-center mt-3 ms-lg-20 ">
                <h1 class="text-primary">
                  🔥【胜率如虹，实力见证】🔥
                </h1>
                <h5>
                  "胜率如虹，不仅仅是一串数字的闪耀，它是我们专业团队对足球赛事深刻理解与精准把握的璀璨结晶。每一场赛事的精准预测，都是我们对海量数据细致入微分析的成果展现。在这片绿茵场上，我们用实力书写着不败的传奇，每一场胜利都是对专业与勤奋的最佳证明。"
                </h5>
                <b-button @click="goDwonload()" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary"
                  class="mt-2 mt-lg-3">
                  👉[快速下载FootyForecast]👈
                </b-button>
              </div>
            </div>

            <div class="col-xxl-7 col-lg-7 col-md-7 col-sm-12  align-items-center p-0 m-0">
              <div class=" align-items-center justify-content-center p-0 m-0 mt-10 ">
                <b-img src="@/assets/images/home/banner_2.png" class="fullscreen-image" alt="Responsive image" />
              </div>
            </div>


          </div>
        </div>
      </div> -->

      <!-- <div
        class="card-body  ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30 ps-xl-40 pe-xl-40 bg-white">
        <div class="row align-items-center text-center e_font_family">
          <div
            class="col-xxl-12 col-lg-12 col-md-12 d-lg-flex d-md-flex  align-items-center justify-content-center p-0 m-0">
            <div
              class="col-xxl-5 col-lg-5 col-md-5 col-sm-12 p-0 m-0  col-sm-5 align-items-center justify-content-center ">
              <div class="text-center text-md-center mt-3 ms-lg-20 ">
                <h1 class="text-primary">
                  🤖【AI加持、云分析】🤖
                </h1>
                <h5>
                  "多年的积累，现大模型训练数据已达到10TB，
                  依托先进的AI大模型技术，以及云计算，胜率有保证！"
                </h5>
                <b-button @click="goDwonload()" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary"
                  class="mt-2 mt-lg-3">
                  👉[快速下载FootyForecast]👈
                </b-button>
              </div>
            </div>

            <div class="col-xxl-7 col-lg-7 col-md-7 col-sm-12  align-items-center p-0 m-0">
              <div class=" align-items-center justify-content-center p-0 m-0 mt-10 ">
                <b-img src="@/assets/images/home/banner_3.png" class="fullscreen-image" alt="Responsive image" />
              </div>
            </div>


          </div>
        </div>
      </div> -->



      <!-- <div
        class="card-body  ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30 ps-xl-40 pe-xl-40 bg-white">
        <div class="row align-items-center text-center e_font_family">
          <div
            class="col-xxl-12 col-lg-12 col-md-12 d-lg-flex d-md-flex  align-items-center justify-content-center p-0 m-0">
            <div
              class="col-xxl-5 col-lg-5 col-md-5 col-sm-12 p-0 m-0  col-sm-5 align-items-center justify-content-center ">
              <div class="text-center text-md-center mt-3 ms-lg-20 ">
                <h1 class="text-primary">
                  📕【实时、历史战绩可查】📕
                </h1>
                <h5>
                  "官网定时公布最近七天胜率，以及最近半年的月胜率，
                  接受用户和市场的双重考验！"
                </h5>
                <b-button @click="goDwonload()" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary"
                  class="mt-2 mt-lg-3">
                  👉[快速下载FootyForecast]👈
                </b-button>
              </div>
            </div>

            <div class="col-xxl-7 col-lg-7 col-md-7 col-sm-12  align-items-center p-0 m-0">
              <div class=" align-items-center justify-content-center p-0 m-0 mt-10 ">
                <b-img src="@/assets/images/home/banner_4.png" class="fullscreen-image" alt="Responsive image" />
              </div>
            </div>


          </div>
        </div>
      </div> -->



      <!-- <div
        class="card-body  ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30 ps-xl-40 pe-xl-40 bg-white">
        <div class="row align-items-center text-center e_font_family">
          <div
            class="col-xxl-12 col-lg-12 col-md-12 d-lg-flex d-md-flex  align-items-center justify-content-center p-0 m-0">
            <div
              class="col-xxl-5 col-lg-5 col-md-5 col-sm-12 p-0 m-0  col-sm-5 align-items-center justify-content-center ">
              <div class="text-center text-md-center mt-3 ms-lg-20 ">
                <h1 class="text-primary">
                  📊【深度数据，精准预测】📊
                </h1>
                <h5>
                  "我们深谙足球的魅力在于未知，但FootyForecast以强大的数据分析能力，为您揭开胜利的迷雾。
                  从球队状态到球员表现，从战术布局到历史交锋，一切尽在掌握。让数据说话，让预测更精准！"
                </h5>
                <b-button @click="goDwonload()" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary"
                  class="mt-2 mt-lg-3">
                  👉[快速下载FootyForecast]👈
                </b-button>
              </div>
            </div>

            <div class="col-xxl-7 col-lg-7 col-md-7 col-sm-12  align-items-center p-0 m-0">
              <div class=" align-items-center justify-content-center p-0 m-0 mt-10 ">
                <b-img src="@/assets/images/home/banner_6.png" class="fullscreen-image" alt="Responsive image" />
              </div>
            </div>


          </div>
        </div>
      </div> -->

    </div>
    <!-- <div class="image-container" >
      <b-img src="@/assets/images/open/banner_1.png" class="fullscreen-image" alt="Responsive image" />

      <div class="overlay-text">
        <h1 class="text-primary fs-lg-50 fs-md-30 fs-sm-30">
          <span style="background-color: rgba(255, 255, 255, 0.8);font-weight: bold;">FootyForecast数据驱动足球预测</span>
        </h1>
      </div>

    </div> -->
  </div>
</template>

<script>
import NavHeader from './NavHeader.vue'

export default {
  components: {
    NavHeader
  },
  data() {
    return {
      ifShowLogo: false,
      imgWidth: window.innerWidth
    }
  },
  computed: {


  },
  created() {
    console.log(window.innerWidth);
    if (window.innerWidth <= 768) {
      this.ifShowLogo = true;
    }
  },

  methods: {
    goDwonload() {
      this.$router.push('/DownLoad');
    }
  },
}
</script>

<style scoped>
.overlay {
  width: 100%;
  height: 100%;
  background-color: rgba(9, 9, 9, 0.5);
  /* 灰色半透明蒙版 */
  z-index: 1;
  /* 确保蒙版在视频之上 */
  /* 你可以根据需要调整蒙版的透明度 */
}

.fullscreen-container {
  position: relative;
  /* 设置为相对定位，作为绝对定位元素的参照 */
  width: 100%;
  height: 100vh;
  /* 视口高度 */
  /* overflow: hidden; */
  /* 防止图片溢出 */
}

.nav-header-container {
  position: absolute;
  /* 绝对定位 */
  top: 0;
  /* 顶部对齐 */
  width: 100%;
  /* 宽度占满容器 */
  z-index: 10;
  /* 确保在图片上方 */
  /* 你可以在这里添加更多样式来调整 NavHeader 的外观 */
}

.image-container {
  width: 100%;
  height: 100%;
  /* overflow: hidden; */
  /* 防止图片溢出 */
}

.fullscreen-image {
  width: 100%;
  /* 宽度占满容器 */
  height: auto;
  /* 高度自适应，保持图片宽高比 */
  /* 如果需要，可以添加其他样式来调整图片显示效果 */
}

/* 文字容器样式 */
.overlay-text {
  position: absolute;
  /* 绝对定位 */
  top: 50%;
  /* 垂直居中，但还需要transform来调整 */
  left: 50%;
  /* 水平居中，但还需要transform来调整 */
  transform: translate(-50%, -50%);
  /* 调整位置以完全居中 */
  text-align: center;
  /* 文本居中 */
  width: 100%;
  /* 宽度可以根据需要调整 */
  /* 你可以添加更多的样式，如字体大小、字体家族等 */
}

/* 针对手机屏幕的媒体查询（小于768px） */
@media (max-width: 767.98px) {
  .overlay-text {
    position: absolute;
    /* 绝对定位 */
    top: 50%;
    /* 垂直居中，但还需要transform来调整 */
    left: 50%;
    /* 水平居中，但还需要transform来调整 */
    transform: translate(-50%, -50%);
    /* 调整位置以完全居中 */
    text-align: center;
    /* 文本居中 */
    width: 100%;
    /* 宽度可以根据需要调整 */
    /* 你可以添加更多的样式，如字体大小、字体家族等 */
  }
}


.video-overlay {  
    position: absolute; /* 绝对定位，相对于最近的已定位祖先元素（这里是.video-container） */  
    top: 0; /* 距离顶部0 */  
    left: 0; /* 距离左侧0 */  
    width: 100%; /* 宽度与容器相同 */  
    height: 100%; /* 高度与容器相同 */  
    background-color: rgba(70, 70, 70, 0.5); /* 白色背景，50%透明度 */  
    z-index: 1; /* 确保蒙版在视频之上 */  
}

.section-background-video {  
    width: 100%; /* 视频宽度 */  
    height: 100%; /* 视频高度 */  
    object-fit: cover; /* 保持视频的宽高比，但完全覆盖容器 */  
    object-position: center center; /* 视频在容器中的位置 */  
} 

.video-container {  
    position: relative; /* 使子元素可以相对于这个容器定位 */  
    width: 100%; /* 容器宽度 */  
    height: 100vh; /* 容器高度，这里假设你想让视频全屏显示，所以使用视窗高度 */  
    overflow: hidden; /* 隐藏超出容器的部分 */  
}  
</style>